import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { SagaPipeModule } from '@app/pipes/module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { Addin, AddinModule } from '@techwan/ionic-core';
import { JournalItemComponent } from './components/journal-item/journal-item.component';
import { JournalListComponent } from './components/journal-list/journal-list.component';
import { CallcardStampsService } from './services/callcard-stamps/callcard-stamps.service';
import { JournalToolsProviderService } from './services/journal-tools-provider/journal-tools-provider.service';
import { StampNameProviderService } from './services/stamp-name-provider/stamp-name-provider.service';
import { StampTextProviderService } from './services/stamp-text-provider/stamp-text-provider.service';
import { StampsProxyService } from './services/stamps-proxy/stamps-proxy.service';

const views = [];

const components = [...views, JournalItemComponent, JournalListComponent];

const executables = [];

const providers = [
  ...executables,
  CallcardStampsService,
  JournalToolsProviderService,
  StampsProxyService,
  StampNameProviderService,
  StampTextProviderService
];

@NgModule({
  declarations: [components],
  providers,
  imports: [CommonModule, IonicModule, SagaPipeModule, TranslateModule],
  exports: [JournalListComponent]
})
@Addin({
  name: 'Journal',
  description: 'Components for displaying journal'
})
export class JournalModule extends AddinModule {
  constructor(public readonly injector: Injector) {
    super(injector, components, executables);
  }
}
